module.exports = __webpack_public_path__ + "static/media/profilePic.f4b50e16.png";